import React, { useState, useEffect, useContext } from "react";
import PopDialog from "../../components/popupdialog";
import { ContextProvider } from "../../providers/app.provider";
import { save } from "save-file";

const Upgrade = () => {
  const [modalOpen, setOpen] = useState(false);
  const openModal = () => {
    setOpen(!modalOpen);
  };
  const closeModal = () => {
    setOpen(false);
  };

  useEffect(() => {
    openModal();
  }, []);

  const details = {
    title: "Upgrade Order",
    header: "This DSM upgrade purchase is for one of the following reasons:",
    content: [
      "DSM Replacement",
      "DSM25 to Enterprise upgrade",
      "Nonprod DSM to Prod DSM upgrade",
    ],
  };
  const { upgrade, upgradeDispatch, userDetails } = useContext(ContextProvider);

  const handleChange = (value) => {
    upgradeDispatch({ type: "UGRADE_SUBMIT", payload: value });
  };
  const reset = () => {
    upgradeDispatch({ type: "UGRADE_RESET", payload: "" });
  };
  const onSubmit = () => {
    const obj = {
      userDetails: {
        sfdcID: userDetails.sfdcId,
        username: userDetails.username,
        email: userDetails.email,
        phone: userDetails.phone,
      },
      orderType: "Upgrade Order",
      "license config details": { notes: upgrade },
    };

    save(`${userDetails.sfdcId}.txt`, JSON.stringify(obj, null, 2));
  };

  return (
    <div>
      <PopDialog
        modalOpen={modalOpen}
        closeModal={closeModal}
        details={details}
        value={upgrade}
        handleChange={handleChange}
        reset={reset}
        onSubmit={onSubmit}
      />
    </div>
  );
};

export default Upgrade;
